import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import "./index.css";
import { toast } from "react-toastify";
import { useLoad } from "../../context/Load";
import { useNavigate } from "react-router";
import Tabela from "../../Components/Tabela";
import { BsFiletypeXlsx } from "react-icons/bs";
import modeloImportacaoVendas from "../../assets/Doc/ModeloImportaçãoVendas.xlsx";
import modeloImportacaoValidadorGerente from "../../assets/Doc/ModeloImportaçãoValidadorGerente.xlsx";
import modeloImportacaoValidadorVendedor from "../../assets/Doc/ModeloImportaçãoValidadorVendedor.xlsx";
import modeloImportacaoCampanhaLibertadores from "../../assets/Doc/Modelo de Relatório de campanha libertadores.xlsx";
import moment from "moment";
export default function Importacao() {
  const [importacao, setImportacao] = useState({
    campanha: "",
    importacao: "1",
    arquivoAnexado: "",
  });
  const [listaImportacoes, setListaImportacoes] = useState([]);
  const [arquivoFile, setArquivoFile] = useState(null);
  const [nomeArquivo, setNomeArquivo] = useState(null);
  const [filtroColuna, setFiltroColuna] = useState([]);
  const [novoFiltroColuna, setNovoFiltroColuna] = useState([]);

  const [listaTipoImportacao, setListaTipoImportacao] = useState([
    {
      tipoImportacaoId: "1",
      nome: "Vendas",
      nomeArquivo: "Modelo de Relatório de vendas.xlsx",
    },
    {
      tipoImportacaoId: "2",
      nome: "Vendas 2",
      nomeArquivo: "Modelo de Relatório de vendas 2.xlsx",
    },
    {
      tipoImportacaoId: "3",
      nome: "Validador de apuração (Vendedor)",
      nomeArquivo: "Modelo de Relatório de validador (Vendedor).xlsx",
    },
    {
      tipoImportacaoId: "4",
      nome: "Validador de apuração (Gerente)",
      nomeArquivo: "Modelo de Relatório de validador (Gerente).xlsx",
    },
    {
      tipoImportacaoId: "5",
      nome: "Campanha libertadores",
      nomeArquivo: "Modelo de Relatório de campanha libertadores.xlsx",
    },
  ]);
  const navigate = useNavigate();
  const { load, setLoad } = useLoad();
  const [paginacao, setPaginacao] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const colunas = [
    {
      accessorKey: "data",
      header: "Data / Hora",
      muiTableHeadCellProps: { align: "left" },
      muiTableBodyCellProps: { align: "left" },
    },
    {
      accessorKey: "participanteNome",
      header: "Usuário",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      accessorKey: "importacaoTipoNome",
      header: "Tipo",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      accessorKey: "nomeArquivo",
      header: "Arquivo",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Total",
      id: "mrt-custom-actions-1",
      accessor: (row) => row, // Pode ser ajustado conforme necessário
      Cell: ({ row }) => (
        <div
          className="pointer"
          onClick={() => {
            fnExpurgo(row.original.importacaoId, "", "Log vendas de total");
          }}
        >
          {row.original.total}
        </div>
      ),
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Ok",
      id: "mrt-custom-actions-2",
      accessor: (row) => row, // Pode ser ajustado conforme necessário
      Cell: ({ row }) => (
        <div
          className="pointer"
          onClick={() => {
            fnExpurgo(
              row.original.importacaoId,
              "sucesso",
              "Log vendas de sucesso"
            );
          }}
        >
          {row.original.sucesso}
        </div>
      ),
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Duplicado",
      id: "mrt-custom-actions-3",
      accessor: (row) => row, // Pode ser ajustado conforme necessário
      Cell: ({ row }) => (
        <div
          className="pointer"
          onClick={() => {
            fnExpurgo(
              row.original.importacaoId,
              "duplicado",
              "Log vendas de duplicados"
            );
          }}
        >
          {row.original.duplicado}
        </div>
      ),
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Erro",
      id: "mrt-custom-actions-4",
      accessor: (row) => row, // Pode ser ajustado conforme necessário
      Cell: ({ row }) => (
        <div
          className="pointer"
          onClick={() => {
            fnExpurgo(row.original.importacaoId, "erro", "Log vendas com erro");
          }}
        >
          {row.original.erro}
        </div>
      ),
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Status",
      id: "mrt-custom-actions-5",
      accessor: (row) => row, // Pode ser ajustado conforme necessário
      Cell: ({ row }) => <div>{row.original.status.nome}</div>,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    // {
    //   accessorKey: "status",
    //   header: "Status",
    //   muiTableHeadCellProps: { align: "center" },
    //   muiTableBodyCellProps: { align: "center" },
    // },
  ];

  async function fnExpurgo(id, status, nomeArquivo) {
    try {
      setLoad(true);

      const baseUrl = {
        1: `importacao/venda/expurgo?importacaoId=${id}&importacaoStatusId=${status}`,
        2: `importacao/performance/expurgo?importacaoId=${id}&importacaoStatusId=${status}`,
        3: `importacao/validador-apuracao/vendedor/expurgo?ImportacaoLogId=${id}&Status=${status}`,
        4: `importacao/validador-apuracao/gerente/expurgo?ImportacaoLogId=${id}&Status=${status}`,
        5: `importacao/campanha-libertadores/expurgo?ImportacaoId=${id}&Status=${status}`,
      };

      const url = baseUrl[importacao.importacao] || baseUrl["4"];

      await ApiServices.apiDownloadXlsxGET(url, nomeArquivo);
    } catch (err) {
      console.error("Error downloading file:", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnListaImportacoes() {
    setLoad(true);
    setListaImportacoes([]);
    var url = "";
    try {
      if (importacao.importacao == "1") {
        url = "importacao/venda";
      } else if (importacao.importacao == "2") {
        url = "importacao/performance";
      } else if (importacao.importacao == "3") {
        url = "importacao/vendedor";
      } else if (importacao.importacao == "4") {
        url = "importacao/gerente";
      } else if (importacao.importacao == "5") {
        url = "importacao/campanha-libertadores";
      }

      let response = await ApiServices.apiGet(url);
      
      response.data.forEach((element) => {
        element.data = moment(element.data).format("DD/MM/YYYY HH:mm:ss");
      });

      response.data.sort((a, b) =>
        moment(b.data, "DD/MM/YYYY HH:mm:ss").valueOf() -
        moment(a.data, "DD/MM/YYYY HH:mm:ss").valueOf()
      );

      if (response.statusCode == 200) {
        setListaImportacoes(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnCarregarArquivo(e) {
    setLoad(true);
    try {
      const file = e.target.files[0];
      const dataForm = new FormData();
      dataForm.append("file", file);
      setArquivoFile(dataForm);
      setNomeArquivo(file.name);
      setLoad(false);
    } catch (err) {
      setLoad(false);
      console.error("Erro ao fazer upload:", err);
    } finally {
    }
  }
  async function fnEnviarArquivo() {
    try {
      setLoad(true);
      var url = "";
      if (importacao.importacao == 1) {
        url = "importacao/venda";
      }
      if (importacao.importacao == 2) {
        url = "importacao/performance";
      }
      if (importacao.importacao == 3) {
        url = "importacao/validador-apuracao/vendedor";
      }
      if (importacao.importacao == 4) {
        url = "importacao/validador-apuracao/gerente";
      }
      if (importacao.importacao == 5) {
        url = "importacao/campanha-libertadores";
      }
      let response = await ApiServices.apiUpload(url, arquivoFile);

      setImportacao((prev) => ({
        ...prev,
        arquivoAnexado: "",
      }));
      document.querySelector(".inputUpload").value = "";
      setNomeArquivo("");
      fnListaImportacoes();
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnBaixarModelo() {
    try {
      setLoad(true);
      const response = await fetch(
        importacao.importacao == "1" || importacao.importacao == "2"
          ? modeloImportacaoVendas
          : importacao.importacao == "3"
            ? modeloImportacaoValidadorVendedor
            : importacao.importacao == "4"
              ? modeloImportacaoValidadorGerente
              : importacao.importacao == "5"
                ? modeloImportacaoCampanhaLibertadores
                : ""
      );
      const blob = await response.blob();
      const tipoSelecionado = listaTipoImportacao.find(
        (tipo) => tipo.tipoImportacaoId === importacao.importacao
      );
      const fileName = tipoSelecionado ? tipoSelecionado.nomeArquivo : "";
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(new Blob([blob]));
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  useEffect(() => {
    fnListaImportacoes();
  }, [importacao.importacao]);

  return (
    <>
      <div className="row">
        <span className="tituloPagina">IMPORTAÇÃO</span>
        <div className="row d-flex align-items-end ">
          {/* <div className="col-md-2 mt-3">
            <form autoComplete="off">
              <label>Campanha</label>

              <select
                className="form-select"
                value={importacao.campanha}
                onChange={(e) => {
                  setImportacao((prev) => ({
                    ...prev,
                    campanha: e.target.value,
                  }));
                }}
              >
                <option value="0">Selecione</option>
                {listaCampanha?.map((e, i) => (
                  <option key={i} value={e.campanhaId}>
                    {e.nome}
                  </option>
                ))}
              </select>
            </form>
          </div> */}
          <div className="col-md-4 mt-3">
            <form autoComplete="off">
              <label>Tipo de importação</label>

              <select
                className="form-select"
                value={importacao.importacao}
                onChange={(e) => {
                  setImportacao((prev) => ({
                    ...prev,
                    importacao: e.target.value,
                  }));
                }}
              >
                {/* <option value="0">Selecione</option> */}
                {listaTipoImportacao?.map((e, i) => (
                  <option key={i} value={e.tipoImportacaoId}>
                    {e.nome}
                  </option>
                ))}
              </select>
            </form>
          </div>

          <div className="col-md-2 mt-3">
            <input
              type="file"
              accept=".xlsx"
              className="inputUpload d-none "
              onChange={fnCarregarArquivo}
            />
            <button
              className="btn btn-primary"
              onClick={() => {
                document.querySelector(".inputUpload").click();
              }}
            >
              Escolher arquivo
            </button>
          </div>
          <div className="col-md-2 mt-3">
            <button
              className="btn btn-outline-primary "
              disabled={!nomeArquivo}
              onClick={fnEnviarArquivo}
            >
              Importar arquivo
            </button>
          </div>
          <div className="col-md-4 mt-3">
            <button className="btn btn-secondary " onClick={fnBaixarModelo}>
              {importacao.importacao == "1"
                ? "Baixar modelo de vendas"
                : importacao.importacao == "2"
                  ? "Baixar modelo de vendas 2"
                  : importacao.importacao == "3"
                    ? "Baixar modelo de validador de vendedor"
                    : importacao.importacao == "4"
                      ? "Baixar modelo de validador de gerente"
                      : "Baixar modelo de campanha libertadores"}
            </button>
          </div>
        </div>
        {nomeArquivo && (
          <div className="d-flex align-items-center  mt-3">
            <BsFiletypeXlsx style={{ fontSize: 30 }} />
            <div className="ms-2">{nomeArquivo}</div>
          </div>
        )}
        <b style={{ marginTop: 30 }}>Orientações</b>
        <p style={{ fontSize: 12 }}>
          Para fazer o upload em massa do seu estoque, siga as orientações
          abaixo:
          <br />
          • Clique em "Baixar Modelo" para fazer o download da planilha de
          importação;
          <br />
          • A planilha deve estar no formato .xlsx;
          <br />
          • O arquivo não deve conter células mescladas;
          <br />
          • A primeira linha deve conter o cabeçalho das colunas;
          <br />
          • Deve haver somente uma aba no arquivo;
          <br />
          • Após a importação, veja o resultado de cada registro clicando nos
          números processados;
          <br />
          • No caso de erro no upload, será gerada uma planilha com o descritivo
          do erro de leitura na última coluna. Favor consultar, ajustar e
          carregar novamente.
          <br />
        </p>
      </div>
      <Tabela
        colunas={colunas}
        dados={listaImportacoes}
        setPaginacao={setPaginacao}
        paginacao={paginacao}
        filtroColuna={filtroColuna}
        setFiltroColuna={setFiltroColuna}
      />
    </>
  );
}
